import * as React from 'react';

export interface ISummaryTitleItemProps {
	titleItem: string;
}

const SummaryTitleItem = (props: ISummaryTitleItemProps) => {

	return (<div className="SummaryItem">
		<div className="SummaryItem-name SummaryTitleItem-name">
			<span>{props.titleItem}</span>
		</div>
		<div className="SummaryItem-total SummaryTitleItem-total">
				<span>
					<span>kton</span>
				</span>
		</div>
	</div>)
};

export default SummaryTitleItem;
